import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import { useParams, useLocation } from "react-router-dom"; // Added useLocation
import { useApi } from "../context/ApiContext";

const OpportunityListings = () => {
  const [priceRange, setPriceRange] = useState({ from: 0, to: 10000 });
  const [showFilters, setShowFilters] = useState(false);
  const [category, setCategory] = useState("All Categories");
  const { opportunity_type } = useParams();
  const API_BASE_URL = useApi();
  const location = useLocation(); // Get location object
  
  // Get search parameters from navigation state
  const searchParams = location.state || {};
  const searchTerm = searchParams.searchTerm || '';
  const locationFilter = searchParams.locationFilter || '';

  let [opportunityListings, setOpportunityListings] = useState([]);
  let [filteredListings, setFilteredListings] = useState([]);

  useEffect(() => {
    getOpportunityListings();
  }, [category]);

  useEffect(() => {
    // Apply search filters when listings or search params change
    if (opportunityListings.length > 0) {
      applyFilters();
    }
  }, [opportunityListings, searchTerm, locationFilter]);

  let getOpportunityListings = async () => {
    const categorySlug =
      category === "All Categories" ? "all" : category.toLowerCase().replace(/\s+/g, "-");

    let fetchUrl = `${API_BASE_URL}/opportunity-listings/${categorySlug}/`;

    let response = await fetch(fetchUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    let data = await response.json();
    if (response.status === 200) {
      setOpportunityListings(data);
    } else {
      alert("There is something wrong");
    }
  };

  const applyFilters = () => {
    let filtered = opportunityListings;
    
    // Apply search term filter
    if (searchTerm) {
      filtered = filtered.filter(item => 
        item.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.firm.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Apply location filter
    if (locationFilter) {
      filtered = filtered.filter(item => 
        item.location.toLowerCase().includes(locationFilter.toLowerCase())
      );
    }
    
    setFilteredListings(filtered);
  };

  return (
    <>
      <Navbar />

      {/* Hero Area Start*/}
      <div className="slider-area">
        <div className="single-slider section-overly slider-height2 d-flex align-items-center opportunity-hero">
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="hero-cap text-center">
                  <h2>Find Your Opportunity</h2>
                  {/* Display search info if there are search parameters */}
                  {(searchTerm || locationFilter) && (
                    <p className="mt-2">
                      Showing results for: 
                      {searchTerm && ` "${searchTerm}"`}
                      {searchTerm && locationFilter && ' in '}
                      {locationFilter && ` ${locationFilter}`}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Job List Area Start */}
      <div className="job-listing-area pt-120 pb-120">
        <div className="container">
          <div className="row">
            {/* Filter Toggle Button */}
            <div className="col-12 mb-4 text-center">
              <button
                className="filter-toggle-btn"
                onClick={() => setShowFilters(!showFilters)}
              >
                {showFilters ? "Hide Filters ✖" : "Show Filters ⚙️"}
              </button>
            </div>

            {/* Filters */}
            {showFilters && (
              <div className="col-12 mb-5">
                <div className="filter-card">
                  <h4 className="filter-title">Filter Opportunities</h4>

                  <div className="filter-section">
                    <label>Category</label>
                    <select
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                    >
                      <option>All Categories</option>
                      <option>Tender</option>
                      <option>Handy Work</option>
                      <option>Employment</option>
                      <option>Internship</option>
                      <option>Volunteer</option>
                    </select>
                  </div>

                  <div className="filter-section">
                    <label>Location</label>
                    <select>
                      <option>Anywhere</option>
                      <option>Accra</option>
                      <option>Kumasi</option>
                      <option>Tema</option>
                      <option>Takoradi</option>
                    </select>
                  </div>

                  <div className="filter-section">
                    <label>Budget Range</label>
                    <input
                      type="range"
                      min="0"
                      max="10000"
                      step="100"
                      value={priceRange.to}
                      onChange={(e) =>
                        setPriceRange({ ...priceRange, to: e.target.value })
                      }
                    />
                    <div className="d-flex justify-content-between mt-2">
                      <span>GHS {priceRange.from}</span>
                      <span>GHS {priceRange.to}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Right content - Opportunity Listings */}
            <div className="col-12">
              <section className="featured-job-area">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="count-job mb-35">
                        <span>
                          {filteredListings.length}{" "}
                          {filteredListings.length === 1
                            ? "Opportunity"
                            : "Opportunities"}{" "}
                          found
                        </span>
                      </div>
                    </div>
                  </div>

                  <div>
                    {filteredListings.map((item, index) => (
                      <div style={{ cursor: "pointer" }} onClick={() => window.location.href = `/opportunity-details/${item.id}/${item.title}`} key={index} className="single-job-items mb-30">
                        <div className="job-items">
                          <div className="company-img">
                            <img src={item.icon} className="img-fluid" alt="Company Logo" />
                          </div>
                          <div className="job-tittle job-tittle2">
                            <a href={`/opportunity-details/${item.id}/${item.title}`} >
                              {(() => {
                                const length = item.title.length;
                                let HeadingTag = "h5";
                                if (length <= 15) {
                                  HeadingTag = "h2";
                                } else if (length <= 30) {
                                  HeadingTag = "h3";
                                } else if (length <= 45) {
                                  HeadingTag = "h4";
                                } else if (length <= 60) {
                                  HeadingTag = "h5";
                                } else {
                                  HeadingTag = "h6";
                                }
                                return <HeadingTag>{item.title}</HeadingTag>;
                              })()}
                            </a>
                            <ul>
                              <li>{item.firm}</li>
                              <li>
                                <i className="fas fa-map-marker-alt"></i>
                                {item.location}
                              </li>
                              <li>{item.remuneration}</li>
                            </ul>
                          </div>
                        </div>
                        <div className="items-link items-link2 f-right">
                          <a href={`/opportunity-details/${item.id}/${item.title}`}>{item.modality}</a>
                          <span>{item.posted_ago}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .filter-toggle-btn {
          padding: 12px 25px;
          font-size: 16px;
          font-weight: 600;
          border-radius: 8px;
          border: none;
          background: #1cb906;
          color: #fff;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .filter-toggle-btn:hover {
          background: #17a205;
        }

        .filter-card {
          background: #fff;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
        }

        .filter-title {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #1d1d24;
        }

        .filter-section {
          margin-bottom: 20px;
        }

        .filter-section label {
          font-weight: 500;
          display: block;
          margin-bottom: 8px;
          color: #333;
        }

        .filter-section select,
        .filter-section input[type="range"] {
          width: 100%;
          padding: 10px;
          border-radius: 6px;
          border: 1px solid #ddd;
          font-size: 14px;
        }

        .filter-section select:focus,
        .filter-section input[type="range"]:focus {
          outline: none;
          border-color: #1cb906;
        }
      `}</style>
    </>
  );
};

export default OpportunityListings;